export default __webpack_public_path__ + "static/media/screen5.6e6016d7.png";